import { Component, input, output, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { OverlayModalComponent } from "./overlay-modal/overlay-modal.component";

export interface SelectOption {
  code: string;
  icon?: string;
}

@Component({
  selector: "app-select-modal",
  standalone: true,
  templateUrl: "./select-modal.component.html",
  styleUrls: ["./select-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, TranslateModule, OverlayModalComponent],
})
export class SelectModalComponent {
  readonly title = input.required<string>();
  readonly options = input<SelectOption[]>([]);
  readonly selected = input<string | null>(null);
  readonly mobile = input(false);
  readonly labelFn = input<(code: string) => string>((code) => code);

  readonly backdropClick = output<void>();
  readonly modalClose = output<void>();
  readonly optionSelect = output<string>();
  readonly saveClick = output<void>();
  readonly cancelClick = output<void>();

  public isChosen(code: string) {
    return this.selected() === code;
  }

  public getLabel(code: string): string {
    return this.labelFn()(code);
  }

  public onSelect(code: string, event: Event) {
    event.stopPropagation();
    this.optionSelect.emit(code);
  }
}
